
  import {Component, Vue} from 'vue-property-decorator';
  import {
    Action,
    Getter,
  } from 'vuex-class';
  import Card from '@/components/material/Card.vue';
  import DlgGuestNew from '@/modules/admin/guests/_components/DlgGuestNew.vue';
  import DlgGuestDelete from '@/modules/admin/guests/_components/DlgGuestDelete.vue';
  import DlgGuestUpdate from '@/modules/admin/guests/_components/DlgGuestUpdate.vue';

  @Component({
    components: {DlgGuestUpdate, DlgGuestDelete, DlgGuestNew, Card},
  })
  export default class VGuests extends Vue {
    @Action('admin/guests/read') private read!: () => Promise<void>;
    @Action('admin/ceos/read') private readCeos!: () => Promise<void>;
    @Getter('admin/guests/all') private guests!: any;
    @Getter('admin/ceos/all') private ceos!: any;

    public dlgEditGuest: boolean = false;
    public dlgDeleteGuest: boolean = false;
    public dlgGuest: object = {};

    private headers: any = [
      {
        text: 'Unternehmen',
        align: 'left',
        sortable: true,
        value: 'ceoId',
      },
      {
        text: 'Vorname',
        align: 'left',
        sortable: true,
        value: 'forename',
      },
      {
        text: 'Nachname',
        align: 'left',
        sortable: true,
        value: 'surname',
      },
      {
        text: 'Geschlecht',
        align: 'left',
        sortable: true,
        value: 'gender',
      },
      {
        text: 'Email',
        align: 'left',
        sortable: true,
        value: 'email',
      },
      {
        text: '',
        align: 'left',
        sortable: false,
        value: '',
      },
    ];
    private loading: boolean = false;
    private search: string = '';

    public editGuest(guest) {
      this.dlgGuest = JSON.parse(JSON.stringify(guest));
      this.dlgEditGuest = true;
    }
    public deleteGuest(guest) {
      this.dlgGuest = JSON.parse(JSON.stringify(guest));
      this.dlgDeleteGuest = true;
    }

    private async mounted() {
      this.loading = true;
      await this.readCeos();
      await this.read();
      this.loading = false;
    }

    get parsedGuests() {
      const guests: any[] = [];
      this.guests.forEach((guest) => {
        guest.company = this.getCompany(guest.ceoId);
        if (guest.company) {
          guest.company = guest.company.company;
        }
        guests.push(guest);
      });
      return guests;
    }


    private getCompany(ceoId) {
      return this.ceos.filter((ceo) => ceo.id === ceoId)[0];
    }
  }
